import Cookies from "js-cookie";
import EnvironmentService from "./environmentService";


export default class UserService{


    constructor() {
        this.environmentService = new EnvironmentService();
    }

    async getMe() {
        let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/Users/Me", {
            headers: {
                "Authorization": "Bearer " + Cookies.get("access_token")
            }
        });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json()
            return data;
        }
        else {
            return result;
        }
    }

}